import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  addNewExam,
  addResource,
  bulkAddQuestions,
  bulkDeleteQuestions,
  bulkEditQuestions,
  deleteResourceById,
  deleteUserExam,
  editExam,
  getExamById,
} from "../../endpoints/Assessment/functions";
import { defaultExamData, setNewExamData } from "../../context/initialValues";
import ModifyQuestion from "../../components/Modals/ModifyQuestion";
import ModExamContent from "../../components/Mods/Exam/ModExamContent";

const ModExamPage = (props) => {
  const { examId } = useParams();
  let localBackUp = null;
  const navigate = useNavigate();
  const [deleting, setDeleting] = useState(false);
  const [exam, setExam] = useState(defaultExamData(props.user.id));
  const [questionSelectedId, setQuestionSelectedId] = useState(null);
  const [resources, setResources] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [index, setIndex] = useState(null);
  const [showQuestionModal, setShowQuestionModal] = useState("");
  const visibleQuestion = questions.filter((item) => !item.delete);
  const visibleResources = resources.filter((item) => !item.delete);
  const [changesMade, setChangesMade] = useState({
    exam: false,
    resources: false,
    questions: false,
  });

  useEffect(() => {
    const fetchData = async () => {
      if (examId !== "new") {
        setLoading(true);
        try {
          const response = await getExamById(examId, props.token);
          setExam({
            id: response.exam.id,
            creator_id: response.exam.creator.id,
            name: response.exam.name,
            description: response.exam.description,
          });
          setResources(response.resources);
          setQuestions(response.questions);
        } catch (error) {
          console.log("Error occured at ModExamPage", error);
        }
        setLoading(false);
      }
    };

    fetchData();
  }, [examId, props.token]);

  async function saveExamDetails() {
    try {
      if (examId !== "new" && changesMade.exam) {
        await editExam(examId, props.token, exam);
      } else if (examId === "new") {
        const res = await addNewExam(exam, props.token);
        setExam(setNewExamData(res.id, exam));
        localBackUp = res.id;
      }
    } catch (error) {
      console.log("Error occured at saveExamDetails", error);
    }
  }

  async function handleResources() {
    try {
      const adding = resources.filter((item) => item.localLink && !item.delete);
      const deleting = resources.filter(
        (item) => item.delete && !item.localLink,
      );
      if (adding.length && (exam.id || localBackUp)) {
        for (let i = 0; i < adding.length; i++) {
          const formData = new FormData();
          formData.append("file", adding[i].file);
          formData.append("name", adding[i].name);
          formData.append("related_exam_id", exam.id || localBackUp);
          await addResource(formData, props.token);
        }
      }
      if (deleting.length) {
        for (let i = 0; i < deleting.length; i++) {
          await deleteResourceById(deleting[i].id, props.token);
        }
      }
    } catch (error) {
      console.log("Error occured at handleResources", error);
    }
  }

  async function handleSave() {
    setSaving(true);
    try {
      if (changesMade.exam) {
        await saveExamDetails();
      }
      if (changesMade.resources) {
        await handleResources();
      }
      if (changesMade.questions) {
        await handleQuestions();
      }
      setChangesMade({ exam: false, resources: false, questions: false });
      setSaving(false);
      navigate("/exams");
    } catch (error) {
      console.log("Error occured at handleSave", error);
    }
  }

  async function handleQuestions() {
    const result = { adding: [], deleting: [], editing: [] };
    questions.forEach((item) => {
      if (item.add && !item.id) {
        item.exam_id = exam.id || localBackUp;
        delete item.add;
        result.adding.push(item);
      } else if (item.delete && item.id) {
        result.deleting.push(item.id);
      } else if (item.edit && item.id) {
        delete item.edit;
        result.editing.push(item);
      }
    });
    if (result.adding.length && (exam.id || localBackUp)) {
      try {
        await bulkAddQuestions(result.adding, props.token);
      } catch (error) {
        console.log("Error occured at handleQuestions Adding", error);
      }
    }
    if (result.deleting.length && (exam.id || localBackUp)) {
      try {
        await bulkDeleteQuestions(result.deleting.join(","), props.token);
      } catch (error) {
        console.log("Error occured at handleQuestions Deleting", error);
      }
    }
    if (result.editing.length && (exam.id || localBackUp)) {
      try {
        await bulkEditQuestions(exam.id, result.editing, props.token);
      } catch (error) {
        console.log("Error occured at handleQuestions Editing", error);
      }
    }
  }

  async function deleteExam() {
    if (deleting && examId !== "new") {
      try {
        await deleteUserExam(examId, props.token);
      } catch (error) {
        console.log("Error occured at deleteExam", error);
      }
    }
    navigate("/exams");
  }
  return (
    <>
      <ModExamContent
        examId={examId}
        deleting={deleting}
        setDeleting={setDeleting}
        deleteExam={deleteExam}
        exam={exam}
        changesMade={changesMade}
        setExam={setExam}
        setChangesMade={setChangesMade}
        visibleQuestion={visibleQuestion}
        visibleResources={visibleResources}
        loading={loading}
        resources={resources}
        setShowQuestionModal={setShowQuestionModal}
        questions={questions}
        saving={saving}
        handleSave={handleSave}
        setIndex={setIndex}
        setResources={setResources}
        setQuestionSelectedId={setQuestionSelectedId}
      />
      <ModifyQuestion
        open={showQuestionModal}
        setOpen={setShowQuestionModal}
        questionId={questionSelectedId}
        setQuestions={setQuestions}
        questions={questions}
        setChangesMade={setChangesMade}
        changesMade={changesMade}
        questionIndex={index}
        setIndex={setIndex}
        token={props.token}
        setQuestionId={setQuestionSelectedId}
        examId={exam.id || localBackUp}
      />
    </>
  );
};

export default ModExamPage;
